import { Step } from "react-joyride";
import { UrlRoute } from "../Router";
import Guide, { guides } from "../guides/Guide";
import * as icons from "../icons";
import { useRoute } from "../models/Hooks";
import { hasHouses, hasKey, logout } from "../models/Identity";
import Login from "../screens/Login";
import BillView from "../screens/bill";
import Dashboard from "../screens/dashboard";
import EntryPassView from "../screens/entrypass";
import HouseView, { HouseTitle } from "../screens/houses";
import InhabitantView, { InhabitantTitle } from "../screens/inhabitants";
import LocationView from "../screens/locations";
import MeasureView from "../screens/measure";
import MeterView from "../screens/meter";
import PaymentView from "../screens/payment";
import PostView from "../screens/post";
import ProfileView from "../screens/profile";
import ProjectView from "../screens/project";
import ProvidedServiceView from "../screens/providedService";
import RequestView from "../screens/request";
import VersionView from "../screens/version";
import { MenuBox } from "./Drawer";
import NotificationView from "../screens/notifications";
import PrivacyPolicy from "../screens/PrivacyPolicy";

const projectManageMenu: Step[] = [
    {
        target: '#project-manage-menu',
        title: 'Управление ЖК',
        content: <>В меню <b>Управление ЖК</b> собраны основные разделы системы, необходимые для повседневное работы</>,
    },
    {
        target: '#emploees-menu',
        title: 'Сотрудники',
        content: <><b>Сотрудники</b> Проекта могут
            <ul>
                <li>Брать в работу заявки на услуги</li>
                <li>Администрировать Проект</li>
                <li>Для каждого <b>Сотрудника</b> может быть создан отдельный пользовательский аккаунт</li>
            </ul>
        </>,
    },
    {
        target: '#project-menu-currency',
        title: 'Услуги',
        content: <>В разделе <b>Услуги</b> можно настроить стоимость предоставляемых услуг.
            <p>При создании нового Проекта в нем по умолчанию уже есть услуга <b>Тех обслуживание</b> стоимостью <b>1000 рублей</b></p>
        </>,
    },
    {
        target: '#locations-menu',
        title: 'Локации',
        content: <>
            В разделе <b>Локации</b> можно посмотреть дома, камеры, проходные или любые геолокационные точки.
            <p>В <b>Заявках</b> можно указывать <b>Локации</b> для любой заявки</p>
        </>,
    }
].map(x => {
    return {
        ...x,
        placementBeacon: 'right',
        placement: 'right'
    }
});
guides.projectManageMenu = projectManageMenu;

export interface IAppMenuItem {
    id?: string
    path?: string,
    title?: React.ReactNode,
    tenanted?: boolean,
    hidden?: () => boolean
    icon?: React.ReactNode,
    element?: () => React.ReactNode,
    color?: string
}
export interface IAppMenuNode extends IAppMenuItem {
    children?: (IAppMenuNode | null)[]
}

export type IAppMenu = (IAppMenuItem | null)[];

export const hierarchicalMenu: (IAppMenuNode | null)[] = [{
    title: 'Общее',
    children: [{
        id: 'desktop-menu',
        path: "",
        title: 'Аналитика',
        icon: icons.Analytics,
        element: () => <Dashboard />,
    },
    {
        id: 'measure-menu',
        path: "measure/*",
        title: 'Показания',
        icon: icons.Information,
        hidden: () => !hasHouses() && !hasKey('Measure'),
        element: () => <MeasureView />,
    },
    {
        id: 'request-menu',
        path: "request/*",
        title: 'Заявки',
        icon: icons.Request,
        hidden: () => !hasHouses() && !hasKey('Request'),
        element: () => <RequestView />,
    },
    {
        id: 'providedService-menu',
        path: "service/*",
        title: 'Услуги',
        icon: icons.Services,
        hidden: () => !hasHouses() && !hasKey('ProvidedService'),
        element: () => <ProvidedServiceView />,
    },
    {
        id: 'bill-menu',
        path: "bill/*",
        title: 'Начисления',
        icon: icons.Charges,
        hidden: () => !hasHouses() && !hasKey('Bill'),
        element: () => <BillView />,
    },
    {
        id: 'payment-menu',
        path: "payment/*",
        title: 'Платежи',
        icon: icons.Payments,
        hidden: () => !hasHouses() && !hasKey('Payment'),
        element: () => <PaymentView />,
    },
    {
        id: 'entrypass-menu',
        path: "entrypass/*",
        icon: icons.Car,
        title: 'Пропуска',
        hidden: () => !hasHouses() && !hasKey('EntryPass'),
        element: () => <EntryPassView />,
    }]
},
    null,
{
    id: 'project-manage-menu',
    title: <>Жилой комплекс<Guide guide="projectManageMenu" /></>,
    children: [/**
    {
        id: 'clients-menu',
        path: "clients/*",
        title: 'Клиенты',
        tenanted: true,
        icon: <Mood />,
        element: () => <Clients />,
    },
    {
        id: 'finance-menu',
        path: "finance",
        title: 'Расчеты',
        tenanted: true,
        icon: <CreditCard />,
        element: () => <Finance />,
    },/**
    {
        id: 'project-menu-currency',
        path: "currency",
        title: 'Услуги',
        tenanted: true,
        icon: <LeakAdd />,
        element: () => <CurrencyView />,
    },/**/
        {
            id: 'house-menu',
            path: "house/*",
            icon: icons.Houses,
            title: <HouseTitle />,
            hidden: () => !hasHouses() && !hasKey('House'),
            element: () => <HouseView />,
        },
        {
            id: 'inhabitant-menu',
            path: "inhabitant/*",
            icon: icons.Users,
            title: <InhabitantTitle multiply={true} />,
            hidden: () => !hasHouses() && !hasKey('Inhabitant'),
            element: () => <InhabitantView />,
        },
        {
            id: 'meter-menu',
            path: "meter/*",
            icon: icons.Meter,
            title: 'Счётчики',
            hidden: () => !hasHouses() && !hasKey('Meter'),
            element: () => <MeterView />,
        },
        {
            id: 'news-menu',
            path: "news/*",
            title: 'Новости',
            icon: icons.News,
            hidden: () => !hasHouses() && !hasKey('Post'),
            element: () => <PostView />,
        }/**/,
        {
            id: 'locations-menu',
            path: "locations/*",
            icon: icons.Pin,
            title: 'Локации',
            hidden: () => !hasHouses() && !hasKey('Location'),
            element: () => <LocationView />,
        }/**/]
},
    null,
{
    path: "project/*",
    title: 'Настройки',
    icon: icons.Settings,
    //color: 'primary.main',
    hidden: () => !hasKey('Position') && !hasKey('Employee') && !hasKey('Tariff') && !hasKey('Service') && !hasKey('PeriodicService'),
    element: () => <ProjectView />,
},
{
    title: 'Выход',
    path: "login",
    icon: icons.Logout,
    //color: 'primary.main',
    element: () => {
        logout();
        return <Login />
    },
},
{
    path: "project/:id",
    element: () => <ProjectView />,
},
{
    path: "profile/:id",
    element: () => <ProfileView />,
},
{
    path: "version",
    element: () => <VersionView />,
},
{
    path: "privacy-policy",
    element: () => <PrivacyPolicy />,
},
{
    id: 'main-menu',
    path: "menu",
    element: () => <MenuBox op={true} menu={mobileMenu} />,
},
{
    id: 'notifications',
    path: "notifications",
    element: () => <NotificationView />,
    }];

const mobileMenu = hierarchicalMenu.map(x => ({ ...x }));
mobileMenu[0]!.children = mobileMenu[0]!.children.filter(x => !['desktop-menu', 'measure-menu', 'request-menu', 'bill-menu'].includes(x!.id!));

export const menu: IAppMenu = hierarchicalMenu.reduce((a, b) => b?.children ? [...a, b, ...b.children] : [...a, b], [] as IAppMenu);

export const route = menu.filter(x => x);

export function useAppRoute(menu: IAppMenu, onChange?: (path: string) => any): [UrlRoute, string, number, IAppMenuItem] {
    const [route, path] = useRoute(onChange);
    var rawMenu = (menu as IAppMenuNode[])
        .reduce((a, b) => b?.children ? [...a, b, ...b.children] : [...a, b], [] as IAppMenu)
        .reverse();

    var current = rawMenu.findIndex(x => (x?.path || x?.path === '') && path.startsWith(x.path.replace(/\/\*$/, '').replace(/\/:.*$/, '')));
    return [route, path, current, rawMenu[current]!];
}